import React, { useContext } from "react";
import t from "module/translations";

import XLabelField from "component/labelField/XLabelField";
import { CertificationSessionInterface } from "module/certification/types";

import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";

const CertificationSessionAchievedFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationSessionContext);

  const certificationSessions = entity as CertificationSessionInterface;

  return (
    <XLabelField
      {...{
        ...(certificationSessions.achieved
          ? {
              label: t.yesText,
            }
          : {}),
      }}
    />
  );
};

export default React.memo(CertificationSessionAchievedFieldContainer);
